import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
    fieldsBagName: 'vFields',
    dictionary: {
        en: {
            custom: {
                feedbackMessage: {
                    required: 'The feedback message field is required.'
                }
            }
        }
    }
});

Vue.config.performance = true;

window.app = new Vue({
    el: '#feedbackApp',
    data: {
        name:"",
        email: "",
        feedbackMessage:""
    },
    methods: {
        checkForm(event) {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$refs.form.submit();
                }
            });

            if (event) event.preventDefault();
        }
    }
});

